export interface CrossValidationErrorDisplayProps {
  errors: string[],
  onClose: () => void
}

export const CrossValidationErrorDisplay = (props: CrossValidationErrorDisplayProps) => {

  return <div className={"min-h-[40vh] max-h-[80vh] flex flex-col justify-between"}>
    <div>
      <div className={"text-lg pb-4"}>The following issues need to be corrected in your csv:</div>
      <div className={"overflow-y-auto max-h-[60vh] max-w-[50vh] overflow-x-auto"}>
        { props.errors.map((error, index) => <div className={"p-2 shadow-sm"} key={index}>{error}</div>)}
      </div>
    </div>
    <div className={"flex justify-end"}>
      <button onClick={props.onClose} className={"btn btn-primary"}>
        Close
      </button>
    </div>
  </div>
}